import { render, staticRenderFns } from "./ButtonQRCode.vue?vue&type=template&id=524c71b6&scoped=true"
import script from "./ButtonQRCode.vue?vue&type=script&lang=js"
export * from "./ButtonQRCode.vue?vue&type=script&lang=js"
import style0 from "./ButtonQRCode.vue?vue&type=style&index=0&id=524c71b6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524c71b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('524c71b6')) {
      api.createRecord('524c71b6', component.options)
    } else {
      api.reload('524c71b6', component.options)
    }
    module.hot.accept("./ButtonQRCode.vue?vue&type=template&id=524c71b6&scoped=true", function () {
      api.rerender('524c71b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/productiveAreas/detail/component/ButtonQRCode.vue"
export default component.exports